import { useI18n } from "../../i18n";
import React from "react";
import { Link } from "react-router-dom";

import styles from "./styles/footer.module.css";

const Footer = () => {
  const { t, localizedPath } = useI18n();
  return (
    <React.Fragment>
      <div className={styles["footer"]}>
        <div className={styles["footer-links"]}>
          <ul className={styles["footer-nav-link-list"]}>
            <li className={styles["footer-nav-link-item"]}>
              <Link to={localizedPath("/")}>{t("home")}</Link>
            </li>
            <li className={styles["footer-nav-link-item"]}>
              <Link to={localizedPath("/projects")}>{t("projects")}</Link>
            </li>
            <li className={styles["footer-nav-link-item"]}>
              <Link to={localizedPath("/experience")}>{t("experience")}</Link>
            </li>
            <li className={styles["footer-nav-link-item"]}>
              <Link to={localizedPath("/contact")}>{t("contact")}</Link>
            </li>
          </ul>
        </div>

        <div className={styles["footer-credits"]}>
          <div className={styles["footer-credits-text"]}>{t("rights")}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
